import axiosInstance from "./axios";

// הממשק כפי שהוא מגיע מהשרת
interface ServerChildDto {
  Id: number;
  Name: string;
  IdNumber: string;
  Email: string;
  Age: number;
  birthday?: string;  // <-- הוספה
  School: string;
  AnalystId: number;
}

// הממשק כפי שאנחנו רוצים להשתמש בו בקליינט
export interface ChildDto {
  id: number;
  name: string;
  idNumber: string;
  email: string;
  age: number;
    birthday?: string;  // <-- הוספה
  school: string;
  analystId: number;
}
// פונקציית עזר להמרה מפורמט השרת לפורמט הקליינט
const mapServerToClient = (child: any): ChildDto => {
  // חישוב גיל מתאריך לידה אם קיים
  let age = child.age ?? child.Age;
  if ((!age || isNaN(age)) && child.birthday) {
    const birth = new Date(child.birthday);
    const today = new Date();
    age = today.getFullYear() - birth.getFullYear();
    const m = today.getMonth() - birth.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) age--;
    console.log(age)

  }
  return {
    id: child.code ?? child.Id ?? child.id,
    name: (child.fname && child.lname) ? `${child.fname} ${child.lname}` : (child.Name ?? child.name ?? ''),
    idNumber: child.id ?? child.IdNumber ?? child.idNumber ?? '',
    email: child.email ?? child.Email ?? '',
    age: age || '',
birthday: child.birthday ?? child.Birthday ?? '',
    school: child.educationalInstitution ?? child.EducationalInstitution ?? child.school ?? child.School ?? child.mosad ?? child['מוסד לימודים'] ?? '',
    analystId: child.analystId ?? child.AnalystId ?? child.analyst_id ?? child.analyst ?? null,
     };
};

// פונקציית עזר להמרה מפורמט הקליינט לפורמט השרת
const mapClientToServer = (child: Partial<ChildDto>): Partial<ServerChildDto> => ({
  ...(child.id !== undefined && { Id: child.id }),
  ...(child.name !== undefined && { Name: child.name }),
  ...(child.idNumber !== undefined && { IdNumber: child.idNumber }),
  ...(child.email !== undefined && { Email: child.email }),
  ...(child.age !== undefined && { Age: child.age }),
  ...(child.school !== undefined && { School: child.school }),
  ...(child.analystId !== undefined && { AnalystId: child.analystId })
});

export const ChildService = {
  getAll: async (): Promise<ChildDto[]> => {
    const res = await axiosInstance.get<ServerChildDto[]>("child");
    return res.data.map(mapServerToClient);
  },
  
  getById: async (id: number): Promise<ChildDto> => {
    const res = await axiosInstance.get<ServerChildDto>(`child/${id}`);
    return mapServerToClient(res.data);
  },
  
  add: async (child: Omit<ChildDto, "id">): Promise<ChildDto> => {
    const serverChild = mapClientToServer(child);
    const res = await axiosInstance.post<ServerChildDto>("child", serverChild);
    return mapServerToClient(res.data);
  },
  
  update: async (id: number, child: ChildDto): Promise<ChildDto> => {
    const serverChild = mapClientToServer(child);
    const res = await axiosInstance.put<ServerChildDto>(`child/${id}`, serverChild);
    return mapServerToClient(res.data);
  },
  
  delete: async (id: number): Promise<void> => {
    await axiosInstance.delete(`child/${id}`);
  },
  
  getByAnalystId: async (analystId: number): Promise<ChildDto[]> => {
        const res = await axiosInstance.get<ServerChildDto[]>(`child/analyst/${analystId}`);
    console.log(analystId);
        return res.data.map(mapServerToClient);
  },
};
